import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { useFormik } from "formik";
import { cateringTtkSchema } from "../schemas";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";
const CateringTTK = () => {
  const workingSinceOption = checkboxData.workSinceOption;
  const areaOfWorkingOption = checkboxData.areaOfWorking;
  const { user, language, token, currency } = useUserAuth();
  const merchant_id = user.uid;
  const [merchant, setMerchant] = useState({});
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/thinkstoknow/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = res.data.data;
      const details = data[0].details;
      // const details = rawDetails ? JSON.parse(rawDetails) : null;
      if (details) {
        setMerchant(details);
        // formik.setValues(details);
      }
    } catch (error) {
      console.log(`Error : ${error}`);
    }
  };

  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id, token]);

  const formik = useFormik({
    initialValues: {
      workingSince: merchant?.workingSince || [],
      areaOfWorking: merchant?.areaOfWorking || [],
      vegPrice: Math.floor(merchant?.vegPrice * currency.value) || "",
      nonVegPrice: Math.floor(merchant?.nonVegPrice * currency.value) || "",
      maxCap: merchant?.maxCap || "",
      minCap: merchant?.minCap || "",
    },
    enableReinitialize: true,
    validationSchema: cateringTtkSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          id: merchant_id,
          details: { ...values, vegPrice: Math.floor(values.vegPrice * currency.country_value), nonVegPrice: Math.floor(values.nonVegPrice * currency.country_value) },
        };

        const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 201) {
          toast.success("Things to know added successfully.");
          setMerchant(values);
          formik.setValues(values);
          setTtkEditMode(false);
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
          setTtkEditMode(false);
        } else {
          toast.info(res.data.message || "Request submitted.");
          setTtkEditMode(false);
        }
      } catch (error) {
        console.error(`Error ${error}`);
        toast.error("An error occurred while submitting the data.");
      }
    },
  });
  const [ttkEditMode, setTtkEditMode] = useState(false);
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
         <ThinksToKnowStatus/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h5>
                  {" "}
                  {language === "en"
                    ? "Things to Know"
                    : "जानने योग्य जानकारी भरे"}
                </h5>
              </div>
              <div className="card-body">
                {merchant && (
                  <>
                    <div className="table-responsive">
                      <table
                        className="table text-center"
                        cellPadding={0}
                        cellSpacing={0}
                        style={{ border: "1px solid #fff " }}
                      >
                        <tbody className="ttk_preview">
                          <tr style={{ color: "#41B0FA" }}>
                            <th style={{ width: "25%" }}>Working Since</th>
                            <th style={{ width: "25%" }}>
                              Starting Veg Price Per Plate
                            </th>
                            <th style={{ width: "25%" }}>
                              Starting Non-Veg Price Per Plate
                            </th>
                            <th style={{ width: "25%" }}>Maximum Capacity </th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.workingSince?.map((item, index) => {
                                return <p key={index}>{item.value}</p>;
                              })}
                            </td>

                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.vegPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                              <small
                                className="text-success"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                Per Plate
                              </small>
                            </td>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.nonVegPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                              <small
                                className="text-success"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Per Plate
                              </small>
                            </td>
                            <td>{merchant.maxCap}</td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Minimum Capacity</th>
                            <th>Area Of Working</th>
                          </tr>
                          <tr>
                            <td>{merchant.minCap}</td>
                            <td>
                              {merchant.areaOfWorking?.map((item, index) => {
                                return (
                                  <span key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </span>
                                );
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <center>
                  <button
                    className="btn btn-primary mb-2"
                    onClick={() => setTtkEditMode(!ttkEditMode)}
                  >{`${merchant ? "Make Changes" : "Tell me more about yourself"
                    }`}</button>
                </center>
                {ttkEditMode && (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Working Since <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={workingSinceOption}
                            selected
                            value={formik.values.workingSince}
                            onChange={(workingSince) =>
                              formik.setFieldValue("workingSince", workingSince)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.workingSince &&
                            formik.errors.workingSince ? (
                            <div className="text-danger">
                              {formik.errors.workingSince}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label class="" for="inlineFormInputGroup">  Starting Veg Price (Per Plate)   <span className="text-danger">*</span></label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">{currency?.symbol}</div>
                          </div>
                          <input
                            type="number"
                            placeholder="Veg Price Per Plate"
                            name="vegPrice"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.vegPrice} />
                        </div>
                        {formik.touched.vegPrice && formik.errors.vegPrice ? (
                          <div className="text-danger">
                            {formik.errors.vegPrice}
                          </div>
                        ) : null}
                      </div>
                      <div class="col-md-6">
                        <label class="" for="inlineFormInputGroup"> Non Starting Veg Price (optional) <span className="text-danger">*</span></label>
                        <div class="input-group mb-2">
                          <div class="input-group-prepend">
                            <div class="input-group-text">{currency?.symbol}</div>
                          </div>
                          <input
                            type="number"
                            placeholder="Non Veg Price Per Plate"
                            name="nonVegPrice"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.nonVegPrice} />
                        </div>
                        {formik.touched.nonVegPrice && formik.errors.nonVegPrice ? (
                          <div className="text-danger">
                            {formik.errors.nonVegPrice}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Maximum Capacity
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="maximum Capacity"
                            name="maxCap"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.maxCap}
                          />
                          {formik.touched.maxCap && formik.errors.maxCap ? (
                            <div className="text-danger">
                              {formik.errors.maxCap}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Minimum Capacity
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Minimum Capacity"
                            name="minCap"
                            className="form-control"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.minCap}
                          />
                          {formik.touched.minCap && formik.errors.minCap ? (
                            <div className="text-danger">
                              {formik.errors.minCap}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Area Of Working{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={areaOfWorkingOption}
                            selected
                            value={formik.values.areaOfWorking}
                            onChange={(areaOfWorking) =>
                              formik.setFieldValue(
                                "areaOfWorking",
                                areaOfWorking
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.areaOfWorking &&
                            formik.errors.areaOfWorking ? (
                            <div className="text-danger">
                              {formik.errors.areaOfWorking}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="form-group text-center">
                      <button className="btn btn-primary" type="submit">
                        {ttkEditMode ? "Save Changes" : "Submit"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CateringTTK;
